import { Navigate, useLocation } from 'react-router-dom'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import { getAccessToken, setAccessToken } from '@/config/api/authStore'
import {
  hasCatalogHandoffCode,
  isAuthEnforced,
  isCatalogSsoEnabled,
  redirectToCatalogLogin,
} from '@/config/env'
import { isWhoamiAuthenticated, useWhoami } from '@/hooks/useWhoami'
import PATHS from '@/routes/paths'
import { useEffect } from 'react'

function BounceToCatalog({ from }) {
  useEffect(() => {
    if (hasCatalogHandoffCode()) return
    redirectToCatalogLogin(from || '/')
  }, [from])
  return <RouteSuspenseFallback />
}

/** @param {{ children: import('react').ReactNode }} props */
export default function RequireAuth({ children }) {
  const location = useLocation()
  const whoami = useWhoami()

  if (!isAuthEnforced()) return children
  if (whoami.isEnabled && whoami.isLoading) return <RouteSuspenseFallback />

  if (whoami.isError) {
    setAccessToken(null)
    if (isCatalogSsoEnabled()) return <BounceToCatalog from={location.pathname} />
    return <Navigate to={PATHS.SIGN_IN} state={{ from: location.pathname }} replace />
  }

  const authenticated = isWhoamiAuthenticated(whoami) || Boolean(getAccessToken())
  if (!authenticated) {
    if (isCatalogSsoEnabled()) return <BounceToCatalog from={location.pathname} />
    return <Navigate to={PATHS.SIGN_IN} state={{ from: location.pathname }} replace />
  }

  return children
}
